import base from "./base.service";

const getNotificationList = (payload) => base.get('/notifications/list', { params: payload });
const deleteNotification = id => base.get(`/notifications/deleteNotification/${id}`)
const readNotification = id => base.get(`notifications/readNotification/${id}`)
export const notificationService = {
    getNotificationList,
    deleteNotification, readNotification
}